import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

export interface Breadcrumb {
  link: string;
  ariaLabel: string;
  label: string;
}

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule]
})
export class PageHeaderComponent {
  @Input()
  heading = '';

  @Input()
  description: Array<string> = [];

  @Input()
  breadcrumbs: Array<Breadcrumb> = [];

  @Input()
  background = ''

  @Input()
  link = ''

  @Input()
  linkAriaLabel = ''

  @Input()
  linkLabel = ''
}
